// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import type { DetailedPin } from 'app/packages/pinterest-flow-types/pin';
import withResource, { type Resource } from 'app/common/lib/react/withResource';
import { Icon, Box, Text } from 'gestalt';

type Props = {|
  detailedPin: Resource<DetailedPin>,
  pinId: string,
|};

const STORY_PIN_ICON_CONTAINER_HEIGHT = 20;
const STORY_PIN_ICON_SIZE = 12;
const STORY_PIN_PAGE_COUNT = 1;

const dPath =
  'M21,17.6119404 L21,9.15332448 C21,7.0136795 20.7772185,6.23779253 20.3588815,5.45557032 C19.9405445,4.67334809 19.3266519,4.05945552 18.5444297,3.64111848 C17.7622075,3.22278146 16.9863205,3 14.8466755,3 L6.3880595,3 C6.46224202,2.80834445 6.54669936,2.63211874 6.64111848,2.45557032 C7.05945552,1.67334809 7.67334809,1.05945552 8.45557032,0.64111848 C9.23779253,0.222781464 10.0136795,0 12.1533245,0 L17.8466755,0 C19.9863205,0 20.7622075,0.222781464 21.5444297,0.64111848 C22.3266519,1.05945552 22.9405445,1.67334809 23.3588815,2.45557032 C23.7772185,3.23779253 24,4.0136795 24,6.15332448 L24,11.8466755 C24,13.9863205 23.7772185,14.7622075 23.3588815,15.5444297 C22.9405445,16.3266519 22.3266519,16.9405445 21.5444297,17.3588815 C21.3678813,17.4533006 21.1916556,17.5377581 21,17.6119404 Z M6.15332448,6 L11.8466755,6 C13.9863205,6 14.7622075,6.22278146 15.5444297,6.64111848 C16.3266519,7.05945552 16.9405445,7.67334809 17.3588815,8.45557032 C17.7772185,9.23779253 18,10.0136795 18,12.1533245 L18,17.8466755 C18,19.9863204 17.7772185,20.7622075 17.3588815,21.5444297 C16.9405445,22.3266518 16.3266519,22.9405445 15.5444297,23.3588815 C14.7622075,23.7772186 13.9863205,24 11.8466755,24 L6.15332448,24 C4.0136795,24 3.23779253,23.7772186 2.45557032,23.3588815 C1.67334809,22.9405445 1.05945551,22.3266518 0.64111849,21.5444297 C0.222781467,20.7622075 0,19.9863204 0,17.8466755 L0,12.1533245 C0,10.0136795 0.222781467,9.23779253 0.64111849,8.45557032 C1.05945551,7.67334809 1.67334809,7.05945552 2.45557032,6.64111848 C3.23779253,6.22278146 4.0136795,6 6.15332448,6 Z';

export function StoryPinIcon(props: Props) {
  const { data } = props.detailedPin;
  const pageCount = data ? data.story_pin_data.page_count : null;
  // Had to set height to prevent bouncing when page count renders.
  return (
    <Box display="flex" alignItems="center" height={STORY_PIN_ICON_CONTAINER_HEIGHT}>
      <Icon
        dangerouslySetSvgPath={{ __path: dPath }}
        accessibilityLabel={i18n._('Story Pin Icon', 'Icon indicating this Pin is a story')}
        size={STORY_PIN_ICON_SIZE}
        color="darkGray"
      />
      {pageCount && (
        <Box marginLeft={STORY_PIN_PAGE_COUNT}>
          <Text inline size="xs" weight="bold">
            {pageCount}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default withResource({
  name: 'PinResource',
  key: 'detailedPin',
  options: ({ pinId }: Props) => ({
    id: pinId,
    field_set_key: 'detailed',
  }),
})(StoryPinIcon);
